import * as actions from 'actions/MyAccountActions/bnplActions';
import { LOADING, INIT, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
import { createReducer } from 'utils/reducerUtils';
const defaultState = {
    asyncStatus: INIT,
    data: []
};
const linkedAccountDefaultState = {
    asyncStatus: INIT
};
export const buyNowPayLater = createReducer(actions.GET_BNPL_DETAILS_REQUEST, actions.GET_BNPL_DETAILS_SUCCESS, actions.GET_BNPL_DETAILS_ERROR, defaultState);
export const bnplSummary = createReducer(actions.GET_BNPL_SUMMARY_REQUEST, actions.GET_BNPL_SUMMARY_SUCCESS, actions.GET_BNPL_SUMMARY_ERROR, defaultState);
export const bnplAccountSummary = createReducer(actions.GET_BNPL_ACCOUNT_REQUEST, actions.GET_BNPL_ACCOUNT_SUCCESS, actions.GET_BNPL_ACCOUNT_ERROR, defaultState);
export const bnplMigration = createReducer(actions.GET_BNPL_MIGRATION_STATUS_REQUEST, actions.GET_BNPL_MIGRATION_STATUS_SUCCESS, actions.GET_BNPL_MIGRATION_STATUS_ERROR, defaultState);
export function bnplToken(state = defaultState, action) {
    switch (action.type) {
        case actions.GET_PAYBACK_TOKEN_REQUEST:
            return Object.assign({}, state, {
                asyncStatus: LOADING
            });
        case actions.GET_PAYBACK_TOKEN_SUCCESS:
            return Object.assign({}, state, action['data'], {
                asyncStatus: SUCCESS
            });
        case actions.GET_PAYBACK_TOKEN_ERROR:
            return Object.assign({}, state, {
                asyncStatus: ERROR
            });
        case actions.RESET_PAYBACK_TOKEN:
            return Object.assign({}, state, {
                asyncStatus: INIT
            });
        default:
            return state;
    }
}
export function bnplLinkedAccounts(state = linkedAccountDefaultState, action) {
    switch (action.type) {
        case actions.GET_BNPL_LINKED_ACCOUNTS:
            return Object.assign({}, state, {
                asyncStatus: LOADING
            });
        case actions.GET_BNPL_LINKED_ACCOUNTS_SUCCESS:
            return Object.assign({}, state, {
                asyncStatus: SUCCESS,
                data: action['data']
            });
        case actions.GET_BNPL_LINKED_ACCOUNTS_ERROR:
            return Object.assign({}, state, {
                asyncStatus: ERROR
            });
        case actions.DELINK_BNPL_APP_SUCCESS:
            const deLinkedAccount = Object.assign(Object.assign({}, (state.data && state.data.deLinkedAccount)), { [action.data.merchantUserId]: action.data });
            return Object.assign({}, state, {
                asyncStatus: SUCCESS,
                data: Object.assign(Object.assign({}, state.data), { deLinkedAccount })
            });
        default:
            return state;
    }
}
